import type { ReactElement } from 'react';
import { LanguageSelectorFull } from '@provider-directory/components/language-selector/language-selector-full.component';
import { MontefioreHeader } from './header';

export function MontefioreMmcHeaderWrapper(_props: {
  className?: string;
}): ReactElement {
  return (
    <>
      <LanguageSelectorFull
        className={
          'block pb-1 pt-2 print:hidden [@media(min-width:1024px)]:hidden'
        }
      />
      <MontefioreHeader />
    </>
  );
}
